/**
 * Simple warning component for browser storage issues
 */

import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';

export function StorageWarning() {
  return (
    <Alert className="mb-4 border-warning/20 bg-warning/10">
      <AlertTriangle className="h-4 w-4 text-warning" />
      <AlertDescription className="text-warning">
        Your browser is blocking data storage. Please check your browser settings to allow data storage for this site to complete authentication.
      </AlertDescription>
    </Alert>
  );
}